/**
 * Created by Christof Sander on 31.01.2017.
 */

/////////////////////////////////////////
/// TweenMax
/////////////////////////////////////////
global.Cubic = {};
